/* BOOSTER+ v64 safe locale selection: use Shopify's native localization form. */
(function () {
  'use strict';
  var CHOICE = 'bk_manual_locale_v64';
  var ATTEMPT = 'bk_auto_locale_attempt_v64';
  function remember(value) {
    try { localStorage.setItem(CHOICE, String(value).toLowerCase()); } catch (e) {}
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('localization-form a[data-value]');
    if (!link) return;
    var form = link.closest('localization-form');
    if (form && form.querySelector('input[name="locale_code"]')) remember(link.getAttribute('data-value'));
  }, true);
  document.addEventListener('submit', function (event) {
    if (!event.isTrusted) return;
    var el = event.target.querySelector && event.target.querySelector('input[name="locale_code"]');
    if (el && el.value) remember(el.value);
  }, true);
  if (window.Shopify && window.Shopify.designMode) return;
  if (/bot|crawler|spider|googlebot|bingbot/i.test(navigator.userAgent)) return;
  try { if (localStorage.getItem(CHOICE) || localStorage.getItem('bk_preferred_language_v63')) return; } catch (e) {}
  var current = document.documentElement.lang.toLowerCase().replace('_', '-');
  var langs = (document.documentElement.dataset.bkLocales || '').toLowerCase().split(',');
  var prefs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
  var wanted = '';
  for (var i=0; i<prefs.length; i++) {
    var p = String(prefs[i]).toLowerCase().replace('_','-');
    if (p.indexOf('zh') === 0) { wanted = /(?:-hk|-tw|-mo|-hant)(?:-|$)/.test(p) ? 'zh-tw' : 'zh-cn'; break; }
    if (p.indexOf('en') === 0) { wanted = 'en'; break; }
  }
  if (!wanted || wanted === current || langs.indexOf(wanted) < 0) return;
  // Do not override Shopify locale or market routes already present in the URL.
  if (/^\/(?:zh-tw|zh-cn|en)(?:\/|$)/i.test(location.pathname)) return;
  var attempt = wanted + ':' + location.pathname;
  try { if (sessionStorage.getItem(ATTEMPT) === attempt) return; } catch(e) {}
  // Native Shopify form calculates the correct language URL for the market/domain.
  function useNativeForm() {
    var forms = document.querySelectorAll('form[action*="/localization"]');
    for (var j=0; j<forms.length; j++) {
      var field = forms[j].querySelector('input[name="locale_code"]');
      if (!field) continue;
      field.value = wanted;
      try { sessionStorage.setItem(ATTEMPT, attempt); } catch(e) {}
      // Submitting the existing Shopify form is safer than constructing /zh-tw URLs.
      HTMLFormElement.prototype.submit.call(forms[j]);
      return;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', useNativeForm, {once:true});
  else useNativeForm();
})();
